import React from "react";
import {
  Plan2PlateDrawer,
  Plan2PlateDrawerHeader,
} from "../../components/Plan2PlateDrawer";
import { NeedCard } from "../../components/need/NeedCard";
import { Button } from "../../components/ui/Button";
import { NeedDefinitionWithEditedFlags } from "../../data/need";

export function PersonNeedDrawer({
  open,
  onClose,
  need,
  personName,
  onUpdateNeed,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  need: NeedDefinitionWithEditedFlags | undefined;
  personName: string | undefined;
  onUpdateNeed: (
    updater: (draft: NeedDefinitionWithEditedFlags) => void,
  ) => void;
  onSave: () => void | Promise<void>;
}) {
  return (
    <Plan2PlateDrawer
      open={open}
      onClose={onClose}
      header={<Plan2PlateDrawerHeader heading="Bedarf ändern" />}
      body={
        need ? (
          <NeedCard
            need={need}
            personName={personName}
            updateNeed={onUpdateNeed}
          />
        ) : null
      }
      footer={
        need?.edited ? (
          <Button fullWidth onClick={onSave}>
            ✓ Speichern
          </Button>
        ) : undefined
      }
    />
  );
}
